<template>
  <div class="card-wrap">
    <div class="card-title">{{ $dataCheck(card.title) }}</div>
    <div class="number-wrap font-manrope">
      <div class="number-left">{{ $dataCheck(card.number) }}</div>
      <div class="number-right" v-if="!card.notCompare">
        <span :style="{ color: card.rise ? '#F23E55' : '#16C97B' }">{{ $dataCheck(card.rate) }}%</span>
        <i
          class="iconfont iconChevron-Top"
          :style="card.rise ? 'color: #F23E55' : 'color: #16C97B;transform: rotate(180deg)'"
        ></i>
      </div>
    </div>
    <div class="date-contrast" v-if="!card.notCompare">
      <div class="contrast-item">
        <div class="date-time">{{ preMonth }}</div>
        <div class="date-num">{{ $dataCheck(card.pre) }}</div>
      </div>
      <div class="contrast-item">
        <div class="date-time">{{ nextMonth }}</div>
        <div class="date-num">{{ $dataCheck(card.next) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      preMonth: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      nextMonth: moment().format('YYYY-MM-DD'),
    }
  },
  props: {
    card: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.card-wrap {
  padding: 24px 16px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
  .card-title {
    font-size: 12px;
    color: #8a909d;
    margin-bottom: 12px;
  }
  .number-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .number-left {
      font-size: 22px;
      font-weight: bold;
      color: #010517;
    }
    .number-right {
      font-size: 14px;
      display: flex;
      align-items: center;
      font-weight: bold;
      .iconChevron-Top {
        font-size: 24px;
      }
    }
  }
  .date-contrast {
    display: flex;
    background: #fafbfc;
    border-radius: 4px;
    margin-top: 16px;
    .contrast-item {
      font-size: 12px;
      padding: 12px 0;
      flex: 1;
      text-align: center;
      &:first-child {
        border-right: 1px solid #e5e9f2;
      }
      .date-time {
        color: #8a909d;
        margin-bottom: 10px;
      }
      .date-num {
        font-weight: bold;
        color: #010517;
      }
    }
  }
}
</style>
